import { Divider } from '@byecode/ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import type { FileItemAction } from '../../../types'
import * as CM from './styles'

interface FileItemProps {
    options: { label: string; value: FileItemAction }[]
    // onRemove: (id: string) => void
    // onPreview?: () => void
    handleAction: (action: FileItemAction) => void
    onClose?: () => void
}

const SCxDrawerContainer = styled.div`
    width: 100%;

    ${CM.Item}:not(:first-child) {
        border-top: 1px solid var(--color-gray-200);
    }
`

const FileItem: React.FunctionComponent<FileItemProps> = ({ options, handleAction, onClose }) => {
    const { t } = useTranslation()

    return (
        <CM.FileItem>
            <SCxDrawerContainer>
                {options.map(({ label, value }) => (
                    <CM.Item onClick={() => handleAction(value)} key={value}>
                        {t(label)}
                    </CM.Item>
                ))}
            </SCxDrawerContainer>
            <Divider style={{ borderWidth: 8 }} color="var(--color-gray-100)" />
            <CM.Footer onClick={onClose}>{t('cancel')}</CM.Footer>
        </CM.FileItem>
    )
}

export default FileItem
